import React from 'react';
import './ProgressBar.css';

/**
 * ProgressBar component to display the progress of a book
 * @param {*} currentPage - The current page of the book
 * @param {*} totalPages - The total number of pages in the book
 * @returns 
 */
function ProgressBar ({ currentPage, totalPages }) {
  const progressPercentage = (currentPage / totalPages) * 100;

  return (
    <div className="progress-bar">
      <div
        className="progress"
        style={{ width: `${progressPercentage}%` }}
      ></div>
    </div>
  );
};

export default ProgressBar;
